import { render, staticRenderFns } from "./nine_boxgrid.vue?vue&type=template&id=2db86ca0&scoped=true"
import script from "./nine_boxgrid.vue?vue&type=script&lang=js"
export * from "./nine_boxgrid.vue?vue&type=script&lang=js"
import style0 from "./nine_boxgrid.vue?vue&type=style&index=0&id=2db86ca0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db86ca0",
  null
  
)

export default component.exports